import BaseViewController from "./base-view-controller";

class AdvanceMedicalAddDependentViewController extends BaseViewController {
  preprocessScreenData() {
    this.screen.fields = this.screen.fields.map(field => {
      if (field.name === "continueButton") {
        return { ...field, action: this.screen.action };
      }
      return field;
    });
  }
}
export default AdvanceMedicalAddDependentViewController;
